// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div {
  width: 100%;
  height: 80vh;
  display: none;
}
div img {
  max-width: 100%;
  max-height: 100%;
}
div embed {
  width: 100%;
  height: 100%;
  display: none;
}
div iframe {
  width: 100%;
  height: 100%;
}
div.isModal {
  height: 100%;
  display: block;
}

@media (min-width: 768px) {
  div {
    box-shadow: 0px 0px 3px var(--accent);
    display: block;
  }
  div embed {
    display: block;
  }
  div iframe {
    display: none;
  }
  div:has(img) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/documentos/preview/preview.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,YAAA;EACA,aAAA;AACD;AAAC;EACC,eAAA;EACA,gBAAA;AAEF;AAAC;EACC,WAAA;EACA,YAAA;EACA,aAAA;AAEF;AAAC;EACC,WAAA;EACA,YAAA;AAEF;AAAC;EACC,YAAA;EACA,cAAA;AAEF;;AAEA;EACC;IACC,qCAAA;IACA,cAAA;EACA;EAAA;IACC,cAAA;EAED;EAAA;IACC,aAAA;EAED;EACD;IACC,aAAA;IACA,uBAAA;IACA,mBAAA;EACA;AACF","sourcesContent":["div {\n\twidth: 100%;\n\theight: 80vh;\n\tdisplay: none;\n\t& img {\n\t\tmax-width: 100%;\n\t\tmax-height: 100%;\n\t}\n\t& embed {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tdisplay: none;\n\t}\n\t& iframe {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n\t&.isModal {\n\t\theight: 100%;\n\t\tdisplay: block;\n\t}\n}\n\n@media (min-width: 768px) {\n\tdiv {\n\t\tbox-shadow: 0px 0px 3px var(--accent);\n\t\tdisplay: block;\n\t\t& embed {\n\t\t\tdisplay: block;\n\t\t}\n\t\t& iframe {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\tdiv:has(img) {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
